import { render, staticRenderFns } from "./Tele2Input.vue?vue&type=template&id=4d61e3d5&scoped=true&"
import script from "./Tele2Input.vue?vue&type=script&lang=js&"
export * from "./Tele2Input.vue?vue&type=script&lang=js&"
import style0 from "./Tele2Input.vue?vue&type=style&index=0&id=4d61e3d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d61e3d5",
  null
  
)

export default component.exports